import React from 'react';
import { Link, useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Header from '../header/header';
import Footer from '../footer/footer';
import SEO from '../seo';
import './layout.scss';

const Layout = ({ children, title, description, image, article, breadcrumbs }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      allMarkdownRemark(
        sort: {frontmatter: {date: DESC}}
        limit: 5
      ) {
        nodes {
          id
          fields {
            slug
          }
          frontmatter {
            title
            album
            artist
            date
            image {
              childImageSharp {
                gatsbyImageData(width: 50, height: 50, placeholder: BLURRED)
              }
            }
          }
        }
      }
      categories: allMarkdownRemark {
        group(field: {frontmatter: {category: SELECT}}) {
          fieldValue
          totalCount
        }
      }
    }
  `);

  const popularSongs = data.allMarkdownRemark.nodes;
  const categories = data.categories.group.sort((a, b) => b.totalCount - a.totalCount);

  return (
    <div className="layout">
      <SEO title={title} description={description} image={image} article={article} />
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <main className="layout__main">
        <div className="content-container">
          {breadcrumbs && (
            <div className="breadcrumbs">
              {breadcrumbs.map((item, index) => (
                <span key={index}>
                  {item.link ? (
                    <Link to={item.link}>{item.text}</Link>
                  ) : (
                    item.text
                  )}
                </span>
              ))}
            </div>
          )}
          <div className="content-wrapper">
            <div className="primary-content">
              {children}
            </div>
            <aside className="sidebar">
              <div className="sidebar-widget">
                <h3 className="widget-title">Popular Songs</h3>
                <div className="widget-content">
                  <ul className="popular-songs-list">
                    {popularSongs.map(song => {
                      const thumbnail = song.frontmatter.image 
                        ? getImage(song.frontmatter.image) 
                        : null;
                      
                      return (
                        <li key={song.id}>
                          <Link to={song.fields.slug} className="popular-song-item">
                            <div className="popular-song-image">
                              {thumbnail ? (
                                <GatsbyImage image={thumbnail} alt={song.frontmatter.title} />
                              ) : (
                                <div className="image-placeholder"></div>
                              )}
                            </div>
                            <div className="popular-song-info">
                              <h4 className="popular-song-title">{song.frontmatter.title}</h4>
                              <p className="popular-song-album">{song.frontmatter.album}</p>
                            </div>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              
              <div className="sidebar-widget">
                <h3 className="widget-title">Categories</h3>
                <div className="widget-content">
                  <ul className="categories-list">
                    {categories.map(category => (
                      <li key={category.fieldValue}>
                        <Link to={`/category/${category.fieldValue.toLowerCase().replace(/\s+/g, '-')}`} className="category-link">
                          {category.fieldValue}
                          <span className="category-count">{category.totalCount}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              
              <div className="sidebar-widget">
                <h3 className="widget-title">Advertisement</h3>
                <div className="widget-content">
                  <div className="ads-container">
                    Advertisement Space
                  </div>
                </div>
              </div>
              
              <div className="sidebar-widget">
                <h3 className="widget-title">Quick Links</h3>
                <div className="widget-content">
                  <ul className="quick-links">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About</Link></li>
                    <li><Link to="/albums">Albums</Link></li>
                    <li><Link to="/artists">Artists</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                  </ul>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;